import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import API_BASE_URL from './config'; // Your API base URL

const ClassSubjectLink = ({ subjects, selectedClassId, selectedClassName, onClose }) => {
    const [selectedSubjectIds, setSelectedSubjectIds] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [initialLinkedSubjectIds, setInitialLinkedSubjectIds] = useState([]);

    useEffect(() => {
        const fetchLinkedSubjects = async () => {
            try {
                const res = await fetch(`${API_BASE_URL}/subjects/link/${selectedClassId}`);
                 if (!res.ok) {
                   const errorData = await res.json();
                   throw new Error(
                     errorData.message || "Failed to fetch linked subjects"
                   );
                 }
                const data = await res.json();
                const linkedIds = data.map(sub => sub.subject_id);
                setInitialLinkedSubjectIds(linkedIds);
                setSelectedSubjectIds(linkedIds);
            } catch (err) {
                setError(err.message || 'Failed to fetch linked subjects');
            }
        };

        if (selectedClassId) {
            fetchLinkedSubjects();
        }
    }, [selectedClassId]);


    const handleSubjectCheckboxChange = (subjectId, isChecked) => {
        setSelectedSubjectIds(prevIds => {
            if (isChecked) {
                return [...prevIds, subjectId];
            } else {
                return prevIds.filter(id => id !== subjectId);
            }
        });
    };

    const saveLinkedSubjects = async () => {
        if (!selectedClassId) {
            alert('No class selected!');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            setLoading(true);
            setError(null);

            const payload = {
                class_id: selectedClassId,
                class_name: selectedClassName, 
                status: 1,               
                subject_ids: selectedSubjectIds, 
            };

            const response = await fetch(`${API_BASE_URL}/classes/${selectedClassId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                const errData = await response.json();
                throw new Error(errData.message || 'Failed to update class.');
            }

            onClose(); 
        } catch (err) {
            setError(err.message);
            alert(`Error: ${err.message}`);
        } finally {
            setLoading(false);
        }

    };



    return (
        <div
            style={{
                display: 'block',
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 1050,
            }}
        >
            <div
                style={{
                    background: '#fff',
                    width: '500px',
                    margin: '100px auto',
                    padding: '20px',
                    borderRadius: '6px',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: '80vh',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '15px',
                    }}
                >
                    <h5 style={{ margin: 0 }}>Subjects List : {selectedClassName}</h5>
                    <button
                        onClick={onClose}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            fontSize: '40px',
                            cursor: 'pointer',
                            color: '#aaa',
                            lineHeight: 1,
                        }}
                        aria-label="Close modal"
                    >
                        &times;
                    </button>
                </div>

                <div style={{ flex: '1 1 auto', overflowY: 'auto', marginBottom: '20px' }}>
                    {subjects.length > 0 ? (
                        subjects.map((subj) => (
                            <div
                                key={subj.subject_id}
                                style={{
                                    padding: '8px 10px',
                                    borderBottom: '1px solid #eee',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}
                            >
                                <span>{subj.subject_name}</span>
                                <input
                                    type="checkbox"
                                    checked={selectedSubjectIds.includes(subj.subject_id)}
                                    onChange={(e) =>
                                        handleSubjectCheckboxChange(subj.subject_id, e.target.checked)
                                    }
                                    style={{
                                        width: '18px',
                                        height: '18px',
                                        cursor: 'pointer',
                                    }}
                                    disabled={loading}
                                />
                            </div>
                        ))
                    ) : (
                        <p>No subjects found.</p>
                    )}
                </div>

                {error && <p style={{ color: 'red' }}>{error}</p>}

                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <button
                        onClick={onClose}
                        disabled={loading}
                        style={{
                            padding: '8px 12px',
                            backgroundColor: '#6c757d',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={saveLinkedSubjects}
                        disabled={loading || selectedSubjectIds.length === 0}
                        style={{
                            padding: '8px 12px',
                            backgroundColor: '#28a745',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: loading ? 'not-allowed' : 'pointer',
                        }}
                    >
                        {loading ? 'Saving...' : 'Save'}
                    </button>
                </div>
            </div>
        </div>
    );
};

ClassSubjectLink.propTypes = {
    subjects: PropTypes.array.isRequired,
    selectedClassId: PropTypes.number.isRequired,
    selectedClassName: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default ClassSubjectLink;
